export default theme => ({
  invalidityContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  invalidityTooltipContainer: {
    '&:not(:last-child)': {
      marginBottom: theme.spacing(0.5)
    }
  },
  invalidityTooltipTitle: {
    textTransform: 'uppercase'
  },
  iconsStyles: {
    fontSize: 14,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(0.75)
  }
});
